import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import { DeclarationContenantEdition } from './declaration-contenant-edition.model';

export class DeclarationMouvementEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        millesime: { key: 'millesime', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        couleur: { key: 'couleur', optional: true, default: '' },
        produitOrigine: { key: 'produitOrigine', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true },
        volume: { key: 'volume', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        contenant: { key: 'contenant', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        dateRetiraison: { key: 'dateRetiraison', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        degre: { key: 'degre', optional: true, default: '' },
        typeRevendication: { key: 'typeRevendication', optional: true, default: '' },
        labelsEnvironnementaux: { key: 'labelsEnvironnementaux', optional: true, default: '' },
        dateConditionnement: { key: 'dateConditionnement', optional: true, default: '' },
        numeroContrat: { key: 'numeroContrat', optional: true, default: '' },
        numeroTirage: { key: 'numeroTirage', optional: true, default: '' },
        volumeVinDeBase: { key: 'volumeVinDeBase', optional: true, default: '' },
        volumeLiqueur: { key: 'volumeLiqueur', optional: true, default: '' },
        contenants: {
            key: 'contenants',
            converter: new (ArrayClassConverterFactory.build(DeclarationContenantEdition))(),
            optional: true
        }
    };

    id: number;
    millesime: string;
    cahier: string;
    produit: string;
    couleur: string;
    produitOrigine: string;
    numeroLot: string;
    numeroDossier: string;
    cepage: number;
    volume: string;
    type: string;
    logement: string;
    contenant: string;
    date: string;
    dateRetiraison: string;
    typeConditionnement: string;
    degre: string;
    typeRevendication: string;
    labelsEnvironnementaux: string;
    dateConditionnement: string;
    numeroContrat: string;
    numeroTirage: string;
    volumeVinDeBase: string;
    volumeLiqueur: string;

    contenants: DeclarationContenantEdition[];
}
